var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        fill: _vm.fillColor,
        width: "30",
        height: "30",
        viewBox: "0 0 105 105",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("circle", { attrs: { cx: "12.5", cy: "12.5", r: "12.5" } }, [
        _c("animate", {
          attrs: {
            attributeName: "fill-opacity",
            begin: "0s",
            calcMode: "linear",
            dur: "1s",
            repeatCount: "indefinite",
            values: "1;.2;1"
          }
        })
      ]),
      _vm._v(" "),
      _c(
        "circle",
        { attrs: { cx: "12.5", cy: "52.5", r: "12.5", "fill-opacity": ".5" } },
        [
          _c("animate", {
            attrs: {
              attributeName: "fill-opacity",
              begin: "100ms",
              calcMode: "linear",
              dur: "1s",
              repeatCount: "indefinite",
              values: "1;.2;1"
            }
          })
        ]
      ),
      _vm._v(" "),
      _c("circle", { attrs: { cx: "52.5", cy: "12.5", r: "12.5" } }, [
        _c("animate", {
          attrs: {
            attributeName: "fill-opacity",
            begin: "300ms",
            calcMode: "linear",
            dur: "1s",
            repeatCount: "indefinite",
            values: "1;.2;1"
          }
        })
      ]),
      _vm._v(" "),
      _c("circle", { attrs: { cx: "52.5", cy: "52.5", r: "12.5" } }, [
        _c("animate", {
          attrs: {
            attributeName: "fill-opacity",
            begin: "600ms",
            calcMode: "linear",
            dur: "1s",
            repeatCount: "indefinite",
            values: "1;.2;1"
          }
        })
      ]),
      _vm._v(" "),
      _c("circle", { attrs: { cx: "92.5", cy: "12.5", r: "12.5" } }, [
        _c("animate", {
          attrs: {
            attributeName: "fill-opacity",
            begin: "800ms",
            calcMode: "linear",
            dur: "1s",
            repeatCount: "indefinite",
            values: "1;.2;1"
          }
        })
      ]),
      _vm._v(" "),
      _c("circle", { attrs: { cx: "92.5", cy: "52.5", r: "12.5" } }, [
        _c("animate", {
          attrs: {
            attributeName: "fill-opacity",
            begin: "400ms",
            calcMode: "linear",
            dur: "1s",
            repeatCount: "indefinite",
            values: "1;.2;1"
          }
        })
      ]),
      _vm._v(" "),
      _c("circle", { attrs: { cx: "12.5", cy: "92.5", r: "12.5" } }, [
        _c("animate", {
          attrs: {
            attributeName: "fill-opacity",
            begin: "700ms",
            calcMode: "linear",
            dur: "1s",
            repeatCount: "indefinite",
            values: "1;.2;1"
          }
        })
      ]),
      _vm._v(" "),
      _c("circle", { attrs: { cx: "52.5", cy: "92.5", r: "12.5" } }, [
        _c("animate", {
          attrs: {
            attributeName: "fill-opacity",
            begin: "500ms",
            calcMode: "linear",
            dur: "1s",
            repeatCount: "indefinite",
            values: "1;.2;1"
          }
        })
      ]),
      _vm._v(" "),
      _c("circle", { attrs: { cx: "92.5", cy: "92.5", r: "12.5" } }, [
        _c("animate", {
          attrs: {
            attributeName: "fill-opacity",
            begin: "200ms",
            calcMode: "linear",
            dur: "1s",
            repeatCount: "indefinite",
            values: "1;.2;1"
          }
        })
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }